import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Icon } from "semantic-ui-react";

export default class Undo extends PureComponent {
    static propTypes = {
        action: PropTypes.func,
        target: PropTypes.string,
    };

    handleClick() {
        this.props.action(this.props.target);
    }

    render() {
        return <Icon name="undo" size="small" onClick={this.handleClick.bind(this)} />;
    }
}



// WEBPACK FOOTER //
// ./src/components/undo.js